import http, { handleApiResponse, checkResponse } from "@/services/http"
import ApiResponse from "@/models/ApiResponse"
import base64toUInt8Array from "@/utils/fileConvert";

export default class ProdPurchaseApi {

  //---------- PDF ----------//
  static printProdPurchasePdf(invoiceId: number): Promise<Uint8Array> {
    return http.get<ApiResponse<string>>(`prod-purchase-invoice/${invoiceId}/report/print-prod-purchase`)
      .then(handleApiResponse)
      .then((x) => {
        return base64toUInt8Array(x);
      });
  }
}